export default {"src":"/_next/static/media/safepoints_24.71fac90c.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};